export const faqsFans = [
    {
      question: "What is Vupop?",
      answer:
        "Vupop is a platform that connects fan content with sports broadcasting. Fans upload match-day clips and broadcasters can request permission to use them.",
    },
    {
      question: "What is fan content in sports?",
      answer:
        "Fan content in sports refers to videos, photos, and other media captured by fans during live sporting events.",
    },
    {
      question: "How does Vupop support sports broadcasting?",
      answer:
        "Vupop provides broadcasters with authentic fan-generated content that can be licensed.",
    },
    {
      question: "Who can upload fan content to Vupop?",
      answer:
        "Any sports fan or content creator can upload their match-day videos.",
    },
    {
      question: "Do fans keep ownership of their fan content?",
      answer: "Yes, fans retain full ownership of their content.",
    },
    {
      question: "Does Vupop replace broadcasters?",
      answer:
        "No, Vupop enhances broadcasting by providing access to authentic fan content.",
    },
    {
      question: "Is Vupop only for professional creators?",
      answer: "No, Vupop is for everyone!",
    },
    {
      question: "Why is fan content important in sports?",
      answer: "Fan content brings authentic emotion and unique perspectives.",
    },
    {
      question: "How do I get started with Vupop?",
      answer: "Download the Vupop app and create an account.",
    },
    {
      question: "Can I monetize my content on Vupop?",
      answer: "Yes! When broadcasters request your content, you get rewarded.",
    },
  ];

  export const faqsBroadcasters = [
  {
    question: "What is Vupop for broadcasters?",
    answer:
      "Vupop is a platform that helps broadcasters access authentic fan content from live sports events to support sports broadcasting and digital coverage.",
  },
  {
    question: "How does Vupop work with fan content?",
    answer:
      "Vupop enables broadcasters to discover, request, and license authentic fan-generated content captured during live sports events.",
  },
  {
    question: "Do broadcasters need to ask fans for permission on Vupop?",
    answer:
      "Yes. Broadcasters can request usage rights directly through the platform, ensuring proper permissions are secured before using fan content.",
  },
  {
    question: "How does Vupop help live and near-live sports broadcasting?",
    answer:
      "Vupop provides quick access to real-time fan content, allowing broadcasters to enhance live and near-live coverage with authentic perspectives.",
  },
  {
    question: "Does Vupop replace professional broadcast footage?",
    answer:
      "No. Vupop complements professional broadcast footage by adding authentic fan-generated moments to enrich coverage.",
  },
  {
    question: "Can Vupop help broadcasters reach younger audiences?",
    answer:
      "Yes. Fan-generated content resonates strongly with younger audiences, helping broadcasters increase engagement across digital platforms.",
  },
  {
    question: "How does Vupop support editorial and production teams?",
    answer:
      "Vupop streamlines content discovery and licensing, making it easier for editorial and production teams to access and integrate fan content efficiently.",
  },
  {
    question: "Is fan content on Vupop authentic?",
    answer:
      "Yes. Content on Vupop is captured by real fans during live sports events, providing genuine and authentic perspectives.",
  },
  {
    question: "Can Vupop be used for social and digital content as well as live broadcasts?",
    answer:
      "Yes. Vupop content can be used across social media, digital platforms, and live broadcasts to enhance audience engagement.",
  },
];

export const faqsBrands = [
  {
    question: "What is Vupop for brands?",
    answer:
      "Vupop helps brands engage fans through authentic fan content created during live sports moments.",
  },
  {
    question: "How can brands use fan content on Vupop?",
    answer:
      "Brands can discover, request permission, and license authentic fan-generated content to use across marketing campaigns and digital platforms.",
  },
  {
    question: "Why should brands use fan content?",
    answer:
      "Fan content feels genuine and relatable, helping brands build stronger emotional connections and increase audience engagement.",
  },
  {
    question: "Do brands need to contact fans for permission?",
    answer:
      "Yes. Brands can request usage rights directly through Vupop to ensure proper permissions are secured before using any fan content.",
  },
  {
    question: "Can brands reward fans for sharing fan content?",
    answer:
      "Yes. When brands request and use fan content, fans can be rewarded through the platform.",
  },
  {
    question: "How does Vupop help brands activate during live sports?",
    answer:
      "Vupop gives brands access to real-time fan moments, enabling timely campaigns and live activations around major sporting events.",
  },
  {
    question: "Can brands use fan content on social media?",
    answer:
      "Yes. Licensed fan content can be used across social media, digital campaigns, and other branded platforms.",
  },
  {
    question: "Does Vupop help brands reach younger audiences?",
    answer:
      "Yes. Authentic fan-generated content resonates strongly with younger demographics, increasing brand relevance and engagement.",
  },
  {
    question: "Why is authenticity important for brands in sport?",
    answer:
      "Authenticity builds trust and emotional connection, making brand messaging more impactful in the sports environment.",
  },
  {
    question: "What types of brands can use Vupop?",
    answer:
      "Any brand looking to engage sports fans through authentic, user-generated content can benefit from using Vupop.",
  },
];